<p-toast key="service_reminder"></p-toast>

<div class="w-full overflow-hidden surface-overlay border-round">
  <p-table
    [value]="reminderData"
    #signedOffIssuesTable
    [rowHover]="true"
    responsiveLayout="scroll"
    scrollHeight="75vh"
    scrollDirection="both"
    [scrollable]="true"
    [responsive]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    styleClass="app-table p-datatable-sm lg:p-datatable-md"
    [globalFilterFields]="[
      'vehicle_reference',
      'service_delta',
      'service_interval',
      'km_reading',
      'service_due_date'
    ]"
  >
    <ng-template pTemplate="caption">
      <div
        class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 py-2"
      >
        <div class="flex align-items-center gap-2">
          <span class="text-800 font-medium">Manage reminders</span>
        </div>

        <div class="w-full md:w-auto">
          <span class="p-input-icon-left p-input-icon-right w-full">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              class="w-full md:w-20rem"
              [value]="searchValue"
              (input)="filterGlobal($event)"
              placeholder="Search keyword"
            />
            <i
              *ngIf="searchValue"
              class="pi pi-times"
              style="cursor:pointer"
              (click)="clearSearch()"
            ></i>
          </span>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th
          *ngFor="let col of columns"
          [class.frozen-column]="col.field === 'vehicle_reference'"
          [pSortableColumn]="col.field"
        >
          <div class="flex align-items-center">
            <span>{{ col.header }}</span>
            <p-columnFilter
              type="text"
              [field]="col.field"
              display="menu"
            ></p-columnFilter>
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-reminder>
      <tr>
        <td
          *ngFor="let col of columns"
          [class.mono-cell]="
            col.field === 'service_delta' ||
            col.field === 'km_reading' ||
            col.field === 'service_due_date'
          "
        >
          <span *ngIf="col.field !== 'service_due_date'">{{ reminder[col.field] }}</span>
          <span *ngIf="col.field === 'service_due_date'">{{ reminder[col.field] | date:'dd MMM yyyy' }}</span>
        </td>

        <td class="text-right">
          <button
            type="button"
            pButton
            icon="pi pi-ellipsis-v"
            class="p-button-sm p-button-text p-button-secondary"
            (click)="
              menu.toggle($event);
              storeRowDetail(reminder);
              $event.stopPropagation()
            "
          ></button>

          <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">
          <div class="flex align-items-center justify-content-center py-4">
            <span class="text-800 font-medium text-xl">
              No service reminders
            </span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog #dr key="service_reminder">
  <p-footer>
    <div class="flex justify-content-end gap-2">
      <button
        pButton
        type="button"
        label="No"
        class="p-button-danger"
        (click)="dr.reject()"
      ></button>
      <button
        pButton
        type="button"
        label="Yes"
        class="p-button-primary"
        (click)="dr.accept()"
      ></button>
    </div>
  </p-footer>
</p-confirmDialog>
